import * as React from 'react';
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import useMediaQuery from '@mui/material/useMediaQuery';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import isEmail from 'validator/lib/isEmail';
import isStrongPassword from 'validator/lib/isStrongPassword';

import { Swiper } from 'swiper/react';
import { SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import "./../assets/swiperCss.css";
import 'swiper/css/autoplay';

import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';

import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';

import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material/styles';
import { themeResponsive } from "../../theme/responsiveTheme.js";

import AdminMenuComponent from "../../components/admin/AdminMenuComponent.js";

const responsiveTheme = responsiveFontSizes(themeResponsive);

const widthPageSlide = 600;

const HomePageComponent = ({ loginUserApiRequest, reduxDispatch, setReduxUserState }) => {
  const [validated, setValidated] = useState(false);
  const [loginUserResponseState, setLoginUserResponseState] = useState({
    success: "",
    error: "",
    loading: false,
  });

  const navigate = useNavigate();

  const config = require("../../constants/constants.js")

  const [page, setPage] = useState({});
  const [id, setId] = useState("");
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [description, setDescription] = useState("");
  const [customizedName, setCustomizedName] = useState("");
  const [customizedStreet, setCustomizedStreet] = useState("");
  const [customizedZip, setCustomizedZip] = useState("");
  const [customizedCity, setCustomizedCity] = useState("");
  const [customizedEmail, setCustomizedEmail] = useState("");
  const [customizedTelephone, setCustomizedTelephone] = useState("");
  const [tabAttivo, setTabAttivo] = React.useState('home');
  const [pathImage0, setPathImage0] = useState("");
  const [titleImage0, setTitleImage0] = useState("");
  const [subTitleImage0, setSubTitleImage0] = useState("");
  
  //  const address_marginLeft = "30px";
  const address_marginLeft = "30px";

  const getPageByMenuValueApiRequest = async (menuValue) => {
    console.log("[getPageByMenuValueApiRequest] leggo page con menuValue =", menuValue);
    const url = `/api/pages/menuValue/` + menuValue;
    const { data } = await axios.get(url);
    //console.log(`data =`, data);
    return data
  }

  useEffect(() => {
    getPageByMenuValueApiRequest('HOME').then((data) => {
      console.log(`data 1 =`, data);
      setPage(data);
      setTitle(data?.title.text);
      setSubTitle(data?.subTitle.text);
      setDescription(data?.description.text);
      setTabAttivo('home');
      setId(data?._id);
      setCustomizedName(page?.customizedContent.name.text);
      setCustomizedStreet(page?.customizedContent.street.text);
      setCustomizedZip(page?.customizedContent.zip.text);
      setCustomizedCity(page?.customizedContent.city.text);
      setCustomizedEmail(page?.customizedContent.email.text);
      setCustomizedTelephone(page?.customizedContent.telephone.text);
      setPathImage0(data?.images[0].path);
      setTitleImage0(data?.imagesTitle[0].text);
      setSubTitleImage0(data?.imagesSubTitle[0].text);

      //console.log(`id =`, id);
      //console.log(`page?.images =`, page?.images);
      //console.log(`page?.title.text =`, page?.title.text);
      //console.log(`page?.description.text =`, page?.description.text);
      //console.log(`page?.customizedContent =`, page?.customizedContent);
      //console.log(`page?.customizedContent.name.text =`, page?.customizedContent.zip.text);
      //console.log(`images =`, data?.images);
      //console.log(`images =`, data?.images[0].path);
    })
      .catch((er) => {
        console.log(er);
      });
  }, [tabAttivo, id])


  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const [loginIcon, setLoginIcon] = React.useState(false);

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };



  return (
    <>

      <ThemeProvider theme={responsiveTheme}>

        <Box sx={{ flexGrow: 1 }}>

          <AdminMenuComponent></AdminMenuComponent>

          <Grid container spacing={{ xs: 0, md: 2 }}>

            <Grid
              // isScrollpage
              size={{ xs: 12, md: 12 }}
              padding={{ xs: 0, md: 0 }}
              // isA4page
              //size={{ xs: 12, md: 5 }}
              //padding={{ xs: 0, md: 4 }}
            >

              <Box sx={{ width: { md: { widthPageSlide } } }}>

                <Swiper
                  style={{
                    '--swiper-navigation-color': '#fff',
                    // isScrollpage
                    //
                    // isA4page
                    height: useMediaQuery('(min-width:600px)') ? "500px" : "300px",
                  }}

                  loop={true}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false
                  }}

                  lazy={true}
                  pagination={{
                    clickable: true,
                  }}
                  navigation={true}
                  modules={[Pagination, Navigation, Autoplay]}
                  className="image-dim"
                >

                  <SwiperSlide>
                    <img
                      src={pathImage0}
                      loading="lazy"
                    />
                    <div class="text-overlay">
                      <p>
                        <Typography variant="h6" color='#ffffff'
                          sx={{
                            paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
                            p: 0, m: 0,
                          }}
                        >
                          {titleImage0}
                        </Typography>
                      </p>
                      <p>
                        <Typography variant="h7" color='#dfdfde'
                          sx={{
                            paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 1,
                            p: 0, m: 0,
                          }}
                        >
                          {subTitleImage0}
                        </Typography>
                      </p>
                    </div>
                    <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                  </SwiperSlide>

                  {page.images?.map((itemImg, id) => (

                    (id > 0 &&

                      <SwiperSlide>
                        <img
                          src={itemImg.path}
                          loading="lazy"
                        />
                        <div class="text-overlay">
                          <p>
                            <Typography variant="h6" color='#ffffff'
                              sx={{
                                paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
                                p: 0, m: 0,
                              }}
                            >
                              {itemImg.title}
                            </Typography>
                          </p>
                          <p>
                            <Typography variant="h7" color='#dfdfde'
                              sx={{
                                paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 1,
                                p: 0, m: 0,
                              }}
                            >
                              {itemImg.subTitle}
                            </Typography>
                          </p>
                        </div>
                        <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                      </SwiperSlide>

                    )
                  ))}

                </Swiper>

              </Box>

            </Grid>

            <Grid
              size={{ xs: 12, md: 10 }}
              paddingTop={{ xs: 0, md: 1 }}
              paddingLeft={1}
              paddingRight={3}
              spacing={0}
            >

              <Stack
                spacing={2}
                // isA4page
                //sx={{ flexDirection: { xs: "column", md: "column" }, paddingTop: { xs: 0, md: 4 }, paddingLeft: 0, paddingRight: 0, }}
                // isScrollpage
                sx={{ flexDirection: { xs: "column", md: "column" }, paddingTop: { xs: 0, md: 0 }, paddingLeft: 1, paddingRight: 0, }}
              >

                <Typography
                  sx={{
                    paddingTop: { xs: 2, md: 0 }, paddingBottom: 0, paddingLeft: { xs: 1, md: 0 }, paddingRight: 0,
                    fontFamily: 'Arial',
                    fontWeight: 500,
                    fontSize: 30,
                    color: 'navy',
                  }}
                >
                  <b>{title}</b>
                </Typography>

                <Typography
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 2, paddingRight: 0,
                    fontFamily: 'Arial',
                    fontWeight: 300,
                    fontSize: 20,
                    color: 'navy',
                  }}
                >
                  <em>{subTitle}</em>
                </Typography>

                <Typography
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 2, paddingRight: 0,
                    fontFamily: 'Arial',
                    fontWeight: 100,
                    fontSize: 14,
                    color: 'black',
                  }}
                >
                  {description}
                </Typography>

              </Stack>

              <Box
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  // isA4page
                  height: 30
                  // isScrollpage
                  //height: 30
                }}
              />

              <Grid container
                spacing={2}
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,

                }}
              >
                <Grid size={{ xs: 1, md: 1 }}>

                </Grid>

                <Grid size={{ xs: 8, md: 8 }}>

                  <Paper
                    sx={{
                      paddingTop: 2, paddingBottom: 3, paddingLeft: 2, paddingRight: 2,
                      background: '#cce0e6'

                    }}
                    elevation={6}
                  >

                    <Stack
                      padding={1}
                      spacing={2}
                      sx={{
                        flexDirection: { xs: "column", md: "column" },
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 2, paddingRight: 2
                      }}
                    >

                      <Typography
                        sx={{
                          fontFamily: 'Arial',
                          fontWeight: 500,
                          fontSize: 16,
                          color: '#1070c5ff',
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0
                        }}
                      >
                        <b>{customizedName}</b>
                      </Typography>

                      <Typography
                        sx={{
                          fontFamily: 'Arial',
                          fontWeight: 500,
                          fontSize: 14,
                          color: '#1877cbff',
                          paddingTop: 0, paddingLeft: address_marginLeft, paddingRight: 0
                        }}
                      >
                        {customizedStreet}
                      </Typography>

                      <Typography
                        sx={{
                          fontFamily: 'Arial',
                          fontWeight: 500,
                          fontSize: 14,
                          color: '#1877cbff',
                          paddingTop: 0, paddingLeft: address_marginLeft, paddingRight: 0
                        }}
                      >
                        {customizedZip}&nbsp;{customizedCity}
                      </Typography>

                      <Typography
                        sx={{
                          fontFamily: 'Arial',
                          fontWeight: 500,
                          fontSize: 14,
                          color: '#1877cbff',
                          paddingTop: 0, paddingLeft: address_marginLeft, paddingRight: 0
                        }}
                      >
                        {customizedEmail}
                      </Typography>

                      <Typography
                        sx={{
                          fontFamily: 'Arial',
                          fontWeight: 500,
                          fontSize: 14,
                          color: '#1877cbff',
                          paddingTop: 0, paddingLeft: address_marginLeft, paddingRight: 0
                        }}
                      >
                        {customizedTelephone}
                      </Typography>

                      {/* 
                      <Typography
                        sx={{
                          fontFamily: 'Arial',
                          fontWeight: 500,
                          fontSize: 16,
                          color: '#1070c5ff',
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0
                        }}
                      >
                        <b>{customizedName}</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<em>orari</em>
                      </Typography>

                      <Grid container spacing={4}
                        sx={{
                          paddingTop: 0, paddingLeft: 1, paddingRight: 0
                        }}
                      >
                        <Grid item xs={3}>
                          <Typography
                            sx={{
                              fontFamily: 'Arial',
                              fontWeight: 500,
                              fontSize: 14,
                              color: '#1877cbff',
                              paddingTop: 0, paddingLeft: 0, paddingRight: 0
                            }}
                          >
                            Lunedì
                            <br />
                            Martedì
                            <br />
                            Mercoledì
                            <br />
                            Giovedì
                            <br />
                          </Typography>
                        </Grid>

                        <Grid item xs={2}>
                          <Typography
                            sx={{
                              fontFamily: 'Arial',
                              fontWeight: 500,
                              fontSize: 14,
                              color: '#000000',
                              paddingTop: 0, paddingLeft: 0, paddingRight: 0
                            }}
                          >
                            08.30 - 19.00
                            <br />
                            08.30 - 19.00
                            <br />
                            08.30 - 19.00
                            <br />
                            08.30 - 19.00
                            <br />
                          </Typography>
                        </Grid>

                        <Grid item xs={3}>
                          <Typography
                            sx={{
                              fontFamily: 'Arial',
                              fontWeight: 500,
                              fontSize: 14,
                              color: '#1877cbff',
                              paddingTop: 0, paddingLeft: 0, paddingRight: 0
                            }}
                          >
                            Venerdì
                            <br />
                            Sabato
                            <br />
                            Domenica
                            <br />
                          </Typography>
                        </Grid>

                        <Grid item xs={2}>
                          <Typography
                            sx={{
                              fontFamily: 'Arial',
                              fontWeight: 500,
                              fontSize: 14,
                              color: '#000000',
                              paddingTop: 0, paddingLeft: 0, paddingRight: 0
                            }}
                          >
                            08.30 - 19.00
                            <br />
                            09.00 - 12.00
                            <br />
                            chiuso
                            <br />
                          </Typography>

                        </Grid>

                      </Grid>
            */}

                    </Stack>

                  </Paper>

                </Grid>
              </Grid>

              <Box
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  height: 50
                }}
              />

            </Grid>
          </Grid>

        </Box>

      </ThemeProvider>

    </>

  );
};

export default HomePageComponent;
